import React from 'react'
import ReactDOM from 'react-dom'
import {Provider} from 'react-redux'
import {store} from './store/root'
import ErrorBoundary from '../components/common/ErrorBoundary'
import App from './App'

const appEl = document.getElementById('tukios-payment-app')
window.gck = appEl?.dataset?.recaptchaKey
window.organizationUuid = appEl?.dataset?.organizationUuid
window.organizationId = appEl?.dataset?.organizationId
window.organizationCurrency = appEl?.dataset?.organizationCurrency
window.organizationStripeAccountId = appEl?.dataset?.organizationStripeAccountId
window.paymentFees = {
    show: !!appEl?.dataset?.paymentShowFees,
    percent: parseFloat(appEl?.dataset?.paymentFeePercent),
    cents: parseInt(appEl?.dataset?.paymentFeeFixedCents),
}

if (appEl) {
    ReactDOM.render(
        <ErrorBoundary>
            <Provider store={store}>
                <App />
            </Provider>
        </ErrorBoundary>,
        appEl
    )
}

